// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-next-link-wrapper
import Link from 'next/link'
import React from 'react'

import { gql } from '../../../../../../__generated__/graphql/catalog/gql'
import { GenderNavSectionFragmentFragment } from '../../../../../../__generated__/graphql/catalog/graphql'
import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'

import { Container, SelectedGender } from './styles'

export const GENDER_NAV_SECTION_FRAGMENT = gql(`
  fragment GenderNavSectionFragment on GenderNavSection {
    id
    alternateGenderHandle
    selectedGender
  }
`)

export type GenderNavSectionProps = GenderNavSectionFragmentFragment

export const GenderNavSection: React.FC<GenderNavSectionFragmentFragment> = ({
  alternateGenderHandle,
  selectedGender,
}) => {
  const {
    collections: {
      genderNavSection: { womens, mens },
    },
  } = useTranslation()
  const normalizedGender =
    selectedGender.slice(-1) === 's' ? selectedGender.slice(0, -1) : selectedGender

  return (
    <Container>
      {normalizedGender === 'Women' ? (
        <>
          <SelectedGender>{womens}</SelectedGender>
          <Link href={`/collections/${alternateGenderHandle}`}>{mens}</Link>
        </>
      ) : (
        <>
          <Link href={`/collections/${alternateGenderHandle}`}>{womens}</Link>
          <SelectedGender>{mens}</SelectedGender>
        </>
      )}
    </Container>
  )
}
